﻿$(document).ready(() => {
    let forms = $('form.hubspot:not([class = "vue"])');
    if (forms && forms.length) {
        forms.each((i, e) => $(e).validate());
    }
});